import twix from "twix"; // eslint-disable-line @typescript-eslint/no-unused-vars

const createMomentRange = range => range[0].twix(range[1]);

export default createMomentRange;
